import React from 'react';

import { useTranslation } from 'react-i18next';

import { useOrdersRecognitionSidebarController } from '@entities/sidebar/config/orders-recognition-sidebar';
import { useWidgetModals, WidgetModalController } from '@features';
import { AiGenerateButton } from '@shared/ui';
import { handleWidgetActionFromTwig } from '@entities/widget-card/lib';

export const OrdersRecognitionHost = () => {
    const { toggle } = useOrdersRecognitionSidebarController();
    const { openDetails, openOnlyAdmin } = useWidgetModals();

    const { t } = useTranslation();

    return (
        <>
            <AiGenerateButton
                color="light"
                cb={() => {
                    handleWidgetActionFromTwig({
                        elementIdentifier: 'renderOrdersRecognition',
                        onWidgetAvailable: toggle,
                        onOpenDetails: openDetails,
                        onOpenOnlyAdmin: openOnlyAdmin,
                    });
                }}
                iconName="accountRecognition"
            >
                {t('OrdersRecognitionHost.return.AiGenerateButton')}
            </AiGenerateButton>
            <WidgetModalController />
        </>
    );
};
